const ROLE_DISPLAY_LABELS = Object.freeze({
  BAR_CASHIER: "Bar Cashier",
  RES_CASHIER: "Restaurant Cashier",
  ORDER_MANAGER: "Order Manager",
});

export const getRoleDisplayLabel = (roleName) =>
  ROLE_DISPLAY_LABELS[roleName] ?? roleName;
